module.exports = __webpack_public_path__ + "media/images/mypage/mypage_menu_bg-14e5d666264d0f4d28dc85df82c56570.png";